document.addEventListener('DOMContentLoaded', function() {
  const arCtas = document.querySelectorAll('[data-shopify-model3d-id]')
  arCtas.forEach(cta => {
      cta.addEventListener('click', (e) => {
        dataLayer.push({
          'event': 'PDP AR Model',
          'eventValue': e.target.dataset.shopifyTitle
        });
      });
    });
});
